import { usePagination, DOTS } from '../../utils/usePagination'
import './Pagination.scss'
import { Icon } from '@iconify/react'

const Pagination = (props: any) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 3,
    currentPage,
    pageSize,
  } = props

  const paginationRange: any = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  })

  if (
    currentPage === 0 ||
    !paginationRange?.length ||
    paginationRange.length < 2
  ) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1, pageSize)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1, pageSize)
  }

  let lastPage = paginationRange[paginationRange.length - 1]
  return (
    <div className='paginations'>
      <select
        className='page-size'
        value={pageSize}
        onChange={(e) => {
          const pageSize = e.target.value
          onPageChange(1, pageSize)
        }}
      >
        <option value='10'>10 per page</option>
        <option value='20'>20 per page</option>
        <option value='50'>50 per page</option>
        <option value='100'>100 per page</option>
      </select>
      <ul>
        <li className={currentPage === 1 ? 'disable' : ''} onClick={onPrevious}>
          <Icon icon='line-md:arrow-left' />
        </li>
        {paginationRange.map((pageNumber: any) => {
          if (pageNumber === DOTS) {
            return (
              <li key={'dots'} className='pagination-item dots'>
                &#8230;
              </li>
            )
          }

          return (
            <li
              key={pageNumber + 1}
              className={pageNumber === currentPage ? 'active' : ''}
              onClick={() => onPageChange(pageNumber, pageSize)}
            >
              {pageNumber}
            </li>
          )
        })}
        <li
          className={currentPage === lastPage ? 'disable' : ''}
          onClick={onNext}
        >
          <Icon icon='line-md:arrow-right' />
        </li>
      </ul>
    </div>
  )
}

export default Pagination
